import { AvailableShift, Shift } from '@velove/types';

/**
 * Sort array items by their parsed integer value
 * This function is intended to be used as an argument for Array.prototype.sort
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 *
 * @param {string|number} itemA
 * @param {string|number} itemB
 *
 * @return number
 */
export const sortAscending = (itemA: string | number, itemB: string | number): number => {
  // Attempt to parse items as integers...
  const itemAValue = parseInt(String(itemA), 10);
  const itemBValue = parseInt(String(itemB), 10);

  if (itemAValue < itemBValue) {
    return -1;
  } else if (itemAValue > itemBValue) {
    return 1;
  }
  return 0;
};

export const sortShiftsByDate = (shiftA: Shift, shiftB: Shift): number =>
  sortAvailableShiftsByDate(shiftA.availableShift, shiftB.availableShift);

export const sortAvailableShiftsByDate = (availableShiftA: AvailableShift, availableShiftB: AvailableShift): number => {
  let dateA = -1;
  let dateB = 1;

  try {
    dateA = new Date(availableShiftA.startAt).getTime();
    dateB = new Date(availableShiftB.startAt).getTime();
  } catch {} // eslint-disable-line no-empty

  return dateA - dateB;
};
